import { faCheck, faCheckCircle, faDownload, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, Card } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import DropzoneData from '../../../../components/Dropzone/Dropzone';
import AdminService from '../../../../services/admin.service';
import ExamService from '../../../../services/exam.service';
import { LoaderContext } from '../../../../Context';
import CreateStudentModal from '../../../../components/Modal/CreateStudent.modal';

import { saveAs } from 'file-saver';
import AddInstructorModal from '../../../../components/Modal/AddInstructor.modal';
import TimelyInvigilatorsModal from '../../../../components/Modal/TimelyInvigilators';
import { downloadCSV } from '../../../../components/helper/csv.helper';

interface Item {
    // Define the type for your JSON items here
    id: number;
    name: string;
    // ... other properties
}

const UploadExamShiftCSV = () => {
    let params = useParams();
    let navigate = useNavigate();


    const [pastUploads, setPastUploads] = useState<any>()

    const { loading, setLoading }: any = useContext(LoaderContext);
    const [showCreateStudentModal, setShowCreateStudentModal] = useState<boolean>(false);
    const [stats, setStats] = useState<any>({});
    const [show, setShow] = useState<boolean>(false);


    const [showAddInstructorModal, setShowAddInstructorModal] = useState<boolean>(false);


    const handleUpload = async (files: any) => {
        setLoading(true)
        let fd = new FormData();
        fd.append("userData", files[0]);
        await AdminService.uploadCsvData(params.examId, params.shiftId, fd).then(res => {
            if (res.status === 200) {
                toast.success("File Upload Successfully");
                getPastUploadedData()
                setLoading(false)
            }
        }).catch(e => {
            setLoading(false);
            toast.error(e?.response?.data?.message || e?.response?.data || "Something went wrong");
        })
    }

    const convertToCSV = (data: any[]) => {
        if (!Array.isArray(data) || data.length === 0) return '';
        const csv: string[] = [];
        const columns = Object.keys(data[0]);
        csv.push(columns.join(','));

        data.forEach(item => {
            const row = columns.map(col => {
                let value = item[col];

                if (value === null || value === undefined) {
                    value = '';
                } else {
                    value = String(value);
                }
                value = value.replace(/,/g, ' ').trim();
                return value;
            });
            csv.push(row.join(','));
        });

        return csv.join('\n');
    };

    const convertToCSVNoVerification = (data: any) => {
        const csv = [];
        // ignore avatar, _id field
        const columns = Object.keys(data[0]).filter(col => col !== 'avatar' && col !== '_id');
        let headers = columns.map((col: any) => {
            if (col === 'allocatedCenterId') {
                return 'Center_Name';
            } else if (col === 'rollNo') {
                return 'Roll No';
            } else if (col === 'name') {
                return 'Name';
            } else if (col === 'centerPreference') {
                return 'Center_Preference';
            }
        });
        console.log("Headers: ", headers);
        console.log("Columns: ", columns);
        csv.push(headers.join(','));

        data.forEach((item: any) => {
            const row = columns.map(col => {
                const value = item[col] ? item[col].toString().replace(/,/g, '_') : '';
                return value;
            });
            csv.push(row.join(','));
        });
        return csv.join('\n');
    };

    const convertAndDownloadCSV = (data: any) => {
        const csvData = convertToCSV(data);
        const blob = new Blob([csvData], { type: 'text/csv' });
        saveAs(blob, 'data.csv');
    };

    const getPastUploadedData = async () => {
        await AdminService.getPastUploads(params.examId, params.shiftId).then(res => {
            if (res.status === 200) {
                setPastUploads(res.data)
            }
        })
    }

    const getInstructors = async () => {
        await AdminService.getInstructorByExamShift(params.examId, params.shiftId).then(res => {
            if (res.status === 200) {
                convertAndDownloadCSV(res.data.data.inv);
            }
        }).catch(e => {
            console.log(e)
            toast.error("Invigilator not found")
        })
    }

    const getStats = async () => {
        await AdminService.getStatsByExamShift(params.examId, params.shiftId).then(res => {
            if (res.status === 200) {
                setStats(res.data.data)
            }
        }).catch(e => {
            console.log(e)
            toast.error("Invigilator not found")
        })
    }

    async function handleReqPdf() {
        await AdminService.requestUserUnmatchedImagesPdf(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }

    async function handleReqTopInstructors() {
        await AdminService.requestTopInvigilators(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }

    async function handleReqUserVerifications() {
        await AdminService.requestUserVerifications(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }

    async function handleReqUserDataCSV() {
        await AdminService.requestUserDataCSV(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }

    async function handleIRISCSV() {
        await AdminService.requestIRISExamCSV(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }
    async function handleIRISVerifications() {
        await AdminService.requestIRISExamData(params.examId, params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message || "Request Sent, check back later!");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
    }

    async function handleAbsentCandidatesCSV() {
        setLoading(true);
        await AdminService.absentCandidates(params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    if (!res.data.export_data || res.data.export_data.length === 0) {
                        toast.error("No data found");
                        return;
                    }
                    let csvData = convertToCSV(res.data.export_data);
                    downloadCSV(csvData, "absent_candidates.csv");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
            .finally(() => setLoading(false));
    }

    async function handleInvigilatorLoginTimes() {
        setLoading(true);
        await AdminService.invigilatorLoginTimes(params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    if (!res.data || res.data.length === 0) {
                        toast.error("No data found");
                        return;
                    }
                    let csvData = convertToCSV(res.data);
                    downloadCSV(csvData, "invigilator_login_times.csv");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
            .finally(() => setLoading(false));
    }

    async function handleInvigilatorDownloadStats() {
        setLoading(true);
        await AdminService.invigilatorDownloadStats(params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    if (!res.data?.export_data || res.data?.export_data?.length === 0) {
                        toast.error("No data found");
                        return;
                    }
                    let csvData = convertToCSV(res.data?.export_data);
                    downloadCSV(csvData, "invigilator_download_stats.csv");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
            .finally(() => setLoading(false));
    }

    async function downloadNotStartedCSV() {
        setLoading(true);
        await AdminService.downloadNotStarted(params.shiftId)
            .then(res => {
                if (res.status === 200) {
                    if (!res.data?.final_data || res.data?.final_data?.length === 0) {
                        toast.error("No data found");
                        return;
                    }
                    let csvData = convertToCSV(res.data?.final_data);
                    downloadCSV(csvData, "download_not_started.csv");
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
            .finally(() => setLoading(false));
    }

    async function downloadRecordsWithnoVerification() {
        console.log("Downloading Records with no verification");
        toast.promise(
            AdminService.downloadRecordsWithNoVerification(params.examId, params.shiftId),
            {
                loading: "Downloading Records with no verification...",
                success: (res) => {
                    if (res.status === 200) {
                        if (!res.data?.data?.students || res.data?.data?.students?.length === 0) {
                            return "No data found";
                        }
                        let csvData = convertToCSVNoVerification(res.data?.data?.students);
                        downloadCSV(csvData, "records_with_no_verification.csv");
                        return "Records downloaded successfully!";
                    }
                    return "Something went wrong";
                },
                error: (err) => err.response?.data?.message || err.response?.data || "Something went wrong"
            }
        );
    }
    async function downloadCentersNotSynced() {
        toast.promise(
            AdminService.getCentersNotSynced(params.shiftId),
            {
                loading: "Downloading Centers Not Synced...",
                success: (res) => {
                    if (res.status === 200) {
                        if (!res.data?.export_data || res.data?.export_data?.length === 0) {
                            return "No data found";
                        }
                        let csvData = convertToCSV(res.data?.export_data || []);
                        downloadCSV(csvData, "centers_not_synced.csv");
                        return "Records downloaded successfully!";
                    }
                    return "Something went wrong";
                },
                error: (err) => err.response?.data?.message || err.response?.data || "Something went wrong"
            }
        );
    }
    async function downloadBiometricNotStartedCenters() {
        toast.promise(
            AdminService.getBiometricNotStartedCenters(params.shiftId),
            {
                loading: "Downloading Biometric Not Started Centers...",
                success: (res) => {
                    if (res.status === 200) {
                        if (!res.data?.export_data || res.data?.export_data?.length === 0) {
                            return "No data found";
                        }
                        let csvData = convertToCSV(res.data?.export_data || []);
                        downloadCSV(csvData, "biometric_not_started_centers.csv");
                        return "Records downloaded successfully!";
                    }
                    return "Something went wrong";
                },
                error: (err) => err.response?.data?.message || err.response?.data || "Something went wrong"
            }
        );
    }

    useEffect(() => {
        getPastUploadedData()
        getStats()
    }, [])


    return (
        <>
            <h5 className='text-primary'>Exam Shift Data<div className="text-muted xcn-text-10 xcn-fw-300">{"Shift Id: " + params.shiftId}</div></h5>
            <div className='d-flex  mt-3 align-items-center'>
                <div className='me-2'>
                    <span className='xcn-text-12'>
                        Instructor Count:
                    </span>
                    <span className='xcn-text-12 fw-bold ms-1'>
                        {stats && stats.inv_count ? stats.inv_count : " - "}
                    </span>
                </div>
                <div className='me-2'>
                    <span className='xcn-text-12'>
                        Student Count:
                    </span>
                    <span className='xcn-text-12 fw-bold ms-1'>
                        {stats && stats.student_count ? stats.student_count : " - "}
                    </span>
                </div>
            </div>

            <Card className="bio-card mt-4">
                <Card.Body>
                    <div>
                        <h6 className="text-muted fw-bold">Step 1. Upload User Data</h6>
                        <span className="text-primary xcn-text-12 xcn-link-pointer" onClick={() => window.open("https://exmcen-static.s3.ap-south-1.amazonaws.com/nixauth-demoUpload.zip")}>Download Sample <FontAwesomeIcon icon={faDownload} /></span>
                        <>
                            {pastUploads ?
                                <>
                                    <div>
                                        <Alert variant='success' className='mt-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div className='fw-bold'>File Uploaded</div>
                                                <div className='text-success xcn-text-12 fw-bold'><FontAwesomeIcon icon={faCheckCircle} /> Already Uploaded</div>
                                            </div>
                                            <div className='mt-3 xcn-text-10'>
                                                <span>
                                                    <ol>
                                                        <li>If you want to change data please re-upload in by creating a new shift</li>
                                                        <li>Uploaded data will be used for the exam</li>
                                                        <li>Make sure you have mandatory fields like
                                                            <ul className='fw-bold'>
                                                                <li>
                                                                    Center Id
                                                                </li>
                                                                <li>
                                                                    Name
                                                                </li>
                                                                <li>
                                                                    Zone
                                                                </li>
                                                                <li>
                                                                    City
                                                                </li>
                                                                <li>
                                                                    State
                                                                </li>
                                                                <li>
                                                                    Roll No
                                                                </li>
                                                                <li>
                                                                    Aadhar No
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ol>
                                                </span>
                                            </div>
                                        </Alert>


                                    </div>
                                </>
                                :
                                <div>
                                    <div
                                        className='border border-lg p-5 d-flex flex-column align-items-center'
                                    >
                                        <DropzoneData
                                            handleFileUpload={handleUpload}
                                        />
                                    </div>
                                </div>
                            }
                            <div className='d-flex justify-content-end mt-3 align-items-center'>
                                <Button
                                    variant='success'
                                    size="sm"
                                    onClick={(e: any) => navigate("/dashboard/mapping/" + params.examId + "/" + params.shiftId)}
                                    disabled={pastUploads ? false : true}
                                >Next <FontAwesomeIcon icon={faArrowRight} /> </Button>
                            </div>
                        </>
                        <div>

                        </div>
                    </div >
                </Card.Body>
            </Card>

            <Card className="bio-card mt-4">
                <Card.Body>
                    <div>
                        <h6 className="text-muted fw-bold">Settings</h6>
                        <div className="d-flex gap-2">
                            <Button
                                variant='primary'
                                size="sm"
                                onClick={(e: any) => getInstructors()}
                                disabled={pastUploads ? false : true}
                            >
                                Download Instructors
                            </Button>
                            <Button
                                variant='primary'
                                size="sm"
                                onClick={(e: any) => setShowAddInstructorModal(true)}
                            // onClick={(e: any) => getInstructors()}
                            // disabled={pastUploads ? false : true}
                            >
                                Create Instructors
                            </Button>
                            <Button
                                variant='primary'
                                size="sm"
                                onClick={(e: any) => setShowCreateStudentModal(true)}
                                disabled={pastUploads ? false : true}
                            >Create Single Student </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <Card className="bio-card mt-4">
                <Card.Body>
                    <div>
                        <h6 className="text-muted fw-bold">Generate Reports</h6>
                        <div className="mt-2 d-flex gap-2">
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleReqUserVerifications}
                            >
                                Request User Verifications
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleReqUserDataCSV}
                            >
                                Request User Data CSV
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleReqPdf}
                            >
                                Request User Unmatched Images PDF
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleReqTopInstructors}
                            >
                                Request for Top Invigilators CSV
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={() => setShow(true)}
                            >
                                Request for Time wise invigilators CSV
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleIRISCSV}
                            >
                                Request for IRIS exam csv
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleIRISVerifications}
                            >
                                Request for IRIS exam data
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="bio-card mt-4">
                <Card.Body>
                    <div>
                        <h6 className="text-muted fw-bold">Live Reports</h6>
                        <div className="d-flex gap-2">
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleAbsentCandidatesCSV}
                            >
                                Download Absent Candidates
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleInvigilatorLoginTimes}
                            >
                                Download Invigilator Login Time
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={handleInvigilatorDownloadStats}
                            >
                                Download Invigilator Download Stats
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={downloadNotStartedCSV}
                            >
                                Centers Where Download Not Started CSV 
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={downloadRecordsWithnoVerification}
                            >
                                Download Records with no verifications
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={downloadCentersNotSynced}
                            >
                                Download Centers Not Synced CSV
                            </Button>
                            <Button
                                variant='secondary'
                                size="sm"
                                onClick={downloadBiometricNotStartedCenters}
                            >
                                Download Biometric Not Started Centers CSV
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <CreateStudentModal
                show={showCreateStudentModal}
                handleClose={() => setShowCreateStudentModal(false)}
                examId={params.examId}
                shiftId={params.shiftId}
            />

            <TimelyInvigilatorsModal
                show={show}
                onHide={() => setShow(false)}
            />
            <AddInstructorModal
                show={showAddInstructorModal}
                handleClose={() => setShowAddInstructorModal(false)}
                reload={() => getStats()}
            />

        </>

    )
}

export default UploadExamShiftCSV